<template>
  <nav class="nav">
      <div>
        <span class="brand">
            <router-link :to="home_url">
                <!-- Peasy -->
                <img :src="peasylogo" alt="peasy-logo">
            </router-link>
        </span>
      </div>
      <div>
        <ul class="items">
            <li v-if="accountId" @click.prevent="navigateBasedOnCartStatus" class=" font_regular font_500 text_14" style="display:flex;">
                    <!-- 0 items -->
                    <div class="shopcart">
                        <span class="cart_count">{{currentCart.order_items.length}}</span>
                        <svg version="1.1" id="shopping_x5F_carts_1_" xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 128 128" style="enable-background:new 0 0 128 128" xml:space="preserve"><g id="x341"><path class="st2" d="M45.3 81.2h78V43.7L35.9 25.4l-3.1-12.9-12.6-4.2c0-.2.1-.3.1-.5 0-4.3-3.5-7.8-7.8-7.8S4.7 3.5 4.7 7.8s3.5 7.8 7.8 7.8c1.8 0 3.4-.6 4.7-1.6l9.4 4.7L39 78l-12.5 9.4V103l5.7 7.1c-1.6 1.9-2.5 4.3-2.5 7 0 6 4.9 10.9 10.9 10.9s10.9-4.9 10.9-10.9-4.9-10.9-10.9-10.9c-.9 0-1.8.1-2.6.3l-2.1-3.4h65.6l3.6 6c-2.2 2-3.6 4.9-3.6 8.1 0 6 4.9 10.9 10.9 10.9s10.9-4.9 10.9-10.9-4.9-10.9-10.9-10.9h-.3l-1.3-3.1h12.5V97H32.8v-6.2l12.5-9.6zm0-6.3-4.6-21.4.6 3L59.8 58l3.8 17H45.3zm21.8 0-3.7-16.7 18.1 1.4 1.4 15.3H67.1zm18.8 0-1.4-15 17 1.3v13.7H85.9zm31.2-15.6v15.6h-12.5V61.5l12.5 1v-3.2l-12.5-1V44.4l12.5 2.4v12.5zM35.9 31.2l65.6 12.6V58l-17.3-1.4-1.5-16.4-3.1-.6 1.6 16.8-18.5-1.5-4.3-19.3-3.7-.7 4.4 19.7-18.5-1.5-4.7-21.9zm76.5 81.2c2.6 0 4.7 2.1 4.7 4.7s-2.1 4.7-4.7 4.7-4.7-2.1-4.7-4.7 2.1-4.7 4.7-4.7zm-71.8 0c2.6 0 4.7 2.1 4.7 4.7s-2.1 4.7-4.7 4.7-4.7-2.1-4.7-4.7 2.1-4.7 4.7-4.7z" id="icon_11_"/></g></svg>

                    </div>
                <span class="font_600 uppercase">{{ merchant.currency }}{{ currentCart.summary.grantTotal }}</span>
            </li>
        </ul>
      </div>
    </nav>
</template>

<script>
import {StorageHelpers,SHOP_CONSTANT} from "./merchant/merchantHelper";
import peasylogo from "../../../dashboard/assets/images/external/peasylogo.png"


export default {
    name:"ShopNav",
    data(){
        return {
            cart: {
                currency: "MYR",
                summary: {
                    grantTotal: 0
                },
                order_items:[],
            },
            peasylogo,
        }
    },
    computed: {
        merchant(){
            return this.$store.getters["merchants/getCurrentMerchant"](this.$route.params.accountId);
        },
        accountId() {
            return this.$route.params.accountId;
        },
        order_url() {
            return `/app/accounts/${this.accountId}/order`;
        },
        home_url() {
            return `/app/accounts/${this.accountId}`;
        },
        currentCart(){
            const currentCart = this.$store.getters["carts/getCurrentCart"](this.$route.params.accountId);
            return currentCart;
        },
    },
    async mounted() {
        this.updateOrderAmount();
        // whenever cart update event,
        bus.$on('cart_updated_event', (data) => {
            this.updateOrderAmount();
        });
    },
    watch:{
        '$route.params.accountId'(newValue,oldValue){
            this.updateOrderAmount();
        },
    },
    methods:{
        updateOrderAmount(){
            const existCart = StorageHelpers.getCartById(this.$route.params.accountId);
            // update the order_items_also
            if (existCart.summary?.grantTotal && typeof existCart.summary?.grantTotal === 'number') {
                this.cart = existCart
            }else{
                this.cart.currency = "MYR";
                this.cart.summary.grantTotal = 0;
            }
        },
         navigateBasedOnCartStatus() {
            const cart = StorageHelpers.getCartById(this.$route.params.accountId);
            if (cart?.summary?.order_id && (cart?.summary?.order_status !== SHOP_CONSTANT.ORDER_STATUS.CANCELED)) {
                this.$router.push(`/app/accounts/${this.accountId}/payment`);
            }else{
                this.$router.push(`/app/accounts/${this.accountId}/order`);
            }
        }

    },
}
</script>

<style lang="scss">
@import '~dashboard/assets/scss/widgets/_fonts.scss';

.nav{
    position: sticky;
    z-index: 4;
    top: 0;
    background-color: #B4FF00;
    padding: 0 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 60px;
    margin-bottom: 20px;

    .brand{
        font-size: 2.4rem;
        font-weight: bolder;
        a{
            color: #000;
            font-size: 25px;
            img{
                width: 100px;
                height: 40px;
            }
        }
    }
    .items{
        list-style: none;
        margin: 0;
        font-weight: bold;
        li{
            cursor: pointer;
            a{
                color:  #6d6868;
            }
        }
    }
}

.shopcart{
    position: relative;
    width: 17px;
    margin-right: 8px;
    .cart_count{
        position: absolute;
        top: -12px;
        right: -4px;
    }
}

</style>

